import { action } from '@reatom/framework'

import { Iterable, pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { environmentAtom } from '@root/shared'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import { Trade } from '../model'

import type { TypeHelper } from '@blade/std-lib'
import type { ServicesTxListParams } from '@blade/trade-api-client'

export const fetchTradesRequestAction = action(
  async (
    ctx,
    {
      network,
      ...params
    }: { network: Network.Network } & TypeHelper.OmitKey<
      ServicesTxListParams,
      'network'
    >,
  ) => {
    const { tradeApiClient } = ctx.get(tradeApiClientAtom)
    const {
      assets: { tokenLogosHost, avatarsHost },
    } = ctx.get(environmentAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesTxList, [
        {
          ...params,
          network: Network.toDto(network),
        },
      ]),
    )

    return pipe(
      result,
      Result.map((it) => ({
        nextCursor: it.meta.nextCursor,
        hasNext: it.meta.hasNext,
        data: pipe(
          it.data,
          Iterable.map((dto) =>
            Trade.fromDto(dto, tokenLogosHost, avatarsHost),
          ),
          Iterable.toArray,
        ),
      })),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'fetchTradesRequestAction',
)

export * from './reatom-pair-maker'
